import { render, staticRenderFns } from "./photos_before.vue?vue&type=template&id=6d3885ab&scoped=true&"
import script from "./photos_before.vue?vue&type=script&lang=js&"
export * from "./photos_before.vue?vue&type=script&lang=js&"
import style0 from "./photos_before.vue?vue&type=style&index=0&id=6d3885ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3885ab",
  null
  
)

export default component.exports